import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '@/services/api'

export const useUserStore = defineStore('user', () => {
    const currentUser = ref(null)
    const isAuthenticated = ref(false)
    const loading = ref(false)

    async function checkAuth() {
        const token = localStorage.getItem('auth_token')
        if (!token) {
            isAuthenticated.value = false
            return
        }

        try {
            const { data } = await api.get('/api/auth/check')
            currentUser.value = data.user
            isAuthenticated.value = true
        } catch (error) {
            console.error('Auth check failed:', error)
            isAuthenticated.value = false
            localStorage.removeItem('auth_token')
        }
    }

    async function login(email, password) {
        loading.value = true
        try {
            const { data } = await api.post('/api/auth/login', { email, password })
            localStorage.setItem('auth_token', data.token)
            currentUser.value = data.user
            isAuthenticated.value = true
            return data
        } catch (error) {
            throw error
        } finally {
            loading.value = false
        }
    }

    function logout() {
        localStorage.removeItem('auth_token')
        currentUser.value = null
        isAuthenticated.value = false
    }

    async function updateAvailability(isAvailable) {
        try {
            const userId = currentUser.value?.id
            if (!userId) throw new Error('Usuário não logado')

            // Atualizar localmente primeiro (otimista)
            if (currentUser.value) {
                currentUser.value.is_available = isAvailable ? 1 : 0
            }

            // Fazer chamada API
            await api.put(`/api/users/${userId}/availability`, {
                is_available: isAvailable ? 1 : 0
            })

            return true
        } catch (error) {
            // Reverter em caso de erro
            if (currentUser.value) {
                currentUser.value.is_available = isAvailable ? 0 : 1
            }
            throw error
        }
    }

    return {
        currentUser,
        isAuthenticated,
        loading,
        checkAuth,
        login,
        logout,
        updateAvailability
    }
})
